/**
 * External dependencies
 */
import React from 'react';
import { createRoot } from 'react-dom/client';

/**
 * WordPress dependencies
 */
import domReady from '@wordpress/dom-ready';

/**
 * Internal dependencies
 */
import DataCaptureForm from '../../../components/DataCaptureForm';

domReady(() => {
	for ( const form of document.getElementsByClassName( 'dekode-profundo-data-capture-form' ) ) {
		createRoot(form).render(<DataCaptureForm
			formID={form.dataset.id}
		/>);
	};
});
